/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAllReleases} from '../api'

 export const useQueryGetAllReleases = createReactQueryHook('getAllReleases', getAllReleases)
